import { ReactNode } from "react";
import { BreakableText } from "../../UI/Table/BreakableText.tsx";

export function StackedCell({
  primary,
  secondary,
}: {
  primary: string;
  secondary?: ReactNode;
}) {
  return (
    <div className={"flex flex-col"}>
      <BreakableText className={"text-slate-800"}>{primary}</BreakableText>
      {secondary && (
        <BreakableText className={"text-xs text-slate-400"}>
          {secondary}
        </BreakableText>
      )}
    </div>
  );
}
